import React from 'react'
import { StyledIcon } from '../styled'
import { ReactComponent as Icon } from '../assets/min/twitter.svg'

const Twitter = ({ medium, large }) => (
	<StyledIcon medium={medium} large={large}>
		<Icon />
	</StyledIcon>
)

export default Twitter
